import React from 'react';
import { TableTooltip } from '@nivo/tooltip';
import { isNil } from 'lodash';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { getDisplayValuesForSeries } from 'components/custom_pivot_chart/helpers';

function ScatterNodeTooltip({ color, data: { x, y, size, label, series } }) {
  const { meta } = useReportConfiguration();
  const { reportColumnNames } = meta;
  const seriesDisplayLabel = getDisplayValuesForSeries(meta, series);

  let rows = [];
  const addRow = (title, value) => {
    if (!isNil(title)) {
      rows.push([title, <strong key={`data-${title}`}>{value}</strong>]);
    }
  };

  // For scatter, we dont use meta data, but for bubble, we need formatted
  // values from meta data
  addRow(reportColumnNames.label, label);
  addRow(reportColumnNames.x, x);
  addRow(reportColumnNames.y, y);
  addRow(reportColumnNames.series, seriesDisplayLabel || series);
  addRow(reportColumnNames.size, size);

  return <TableTooltip rows={rows} />;
}

export default ScatterNodeTooltip;
